function disableJavaScript(html) {
    // Create a temporary container element to work with the fetched data
    var tempContainer = $('<div>').html(html);

    // Disable all <script> elements inside the fetched data
    tempContainer.find('script').remove();

    // Return the sanitized HTML data
    return tempContainer.html();
  }
  
$(document).ready(function(){
          $(".main-metafield-image").eq(1).hide(),
          $(".main-metafield-image").eq(0).css('order', -1 )
           $ltvcount = $(".Main--ProductPhotos .product__slide").length

              console.log($ltvcount + " = xxx")
           if($ltvcount == 2){
             $(".Main--ProductPhotos .product__slide:nth-child(2)").hide()
           }
           setTimeout(function() {
            if($("[data-value='S'] label[op_val='S']").length){
                $("[data-value='S'] label[op_val='S']").trigger("click")
              }else{
                $("[data-value='XL'] label[op_val='XL']").trigger("click") 
              }
          }, 500);
           
var intervalId = window.setInterval(function(){
  let carttotal = 0
    let cartitem
    $('.cart__item').each(function(i, obj) {
        cartitem = $(this).find(".qb-price-item").html()
        cartitem = cartitem.replace('$', '');
        cartitem = parseInt(cartitem)
        carttotal = carttotal + cartitem
    });
    $totalin = $(".totalin").html()
    $totalin = $totalin.replace('$', '');
    $totalin = parseInt($totalin)
    if($totalin >= 30){
        $("#cartshipping").html("Free")
    }
}, 2000);

let carttotal = 0
let cartitem
$('.cart__item').each(function(i, obj) {
    cartitem = $(this).find(".qb-price-item").html()
    cartitem = cartitem.replace('$', '');
    cartitem = parseInt(cartitem)
    carttotal = carttotal + cartitem
});
$totalin = $(".totalin").html()
$totalin = $totalin.replace('$', '');
$totalin = parseInt($totalin)
if($totalin >= 97){
    $("#cartshipping").html("Free Shipping")
}


    $(".all-colors label").on("click",function(){
    $class = $(this).attr("datacounter")
    $(".feature-img img").hide()
    $("." + $class).show()
  })

  
    $(".close_button").click(function(){

      $(this).closest('.slide-nav__overflow').removeClass('js-menu--is-open');
      $(this).parent().parent().find('button.btn.site-nav__thumb-button.js-toggle-slide-nav').trigger('click');



    }); 

      $(window).scroll(function(){
      if ($(this).scrollTop() > 50) {
        $('div#shopify-section-header').addClass('fix_header');
      } else {
        $('div#shopify-section-header').removeClass('fix_header');
      }
    });  
   
var checkExist = setInterval(function() {
  var $myDiv = $('#BIS_trigger');

   if ($myDiv.length) {
       if ( $myDiv.length){
		$myDiv.wrap('<div class="bts_container"></div>');
        //you can now reuse  $myDiv here, without having to select it again.
    }
      clearInterval(checkExist);
  }
}, 100);
  function getUrlVars()
  {
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
      hash = hashes[i].split('=');
      vars.push(hash[0]);
      vars[hash[0]] = hash[1];
    }
    return vars;
  }
  
  
  $('.product__thumb-item:eq(0)').trigger('click');
$(document).on('click','.variant-change-color .variant-input-wrap .variant-input',function(){

  $size = $(".variant-input-wrap[data-index='option1'] input:checked").val();
  $color = $(".variant-input-wrap[data-index='option2'] input:checked").val();
  if($(".variant-input-wrap[data-index='option3']").length){
      $inseam = $(".variant-input-wrap[data-index='option3'] input:checked").val();
      var setchosen = $size + " / " + $color + " / " + $inseam;
      setchosen = setchosen.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      $x = parseFloat(comprice[setchosen] / 100).toFixed(2);
      $y = parseFloat(normprice[setchosen] / 100).toFixed(2);
      console.log($x + " | " + $y + " | " + setchosen)
      if(isNaN($x)){
                    
      }else{
        if((typeof $x === "undefined") || ($x == "") || ($x == "0.00")){
          $(".grid-product__price").html('<span data-price="" class="5 normalPrice product__price grid-product__price--original" data-product-price="">$' + $y + '</span>')
        }else{
          $(".grid-product__price").html('<del data-price="" class="5 normalPrice product__price grid-product__price--original ">$' + $x + '</del><div class="sale-price">$' + $y + '</div>')
        }
      }
  }else{
      
      var setchosen = $size + " / " + $color;
      setchosen = setchosen.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      $x = parseFloat(comprice[setchosen] / 100).toFixed(2);
      $y = parseFloat(normprice[setchosen] / 100).toFixed(2);
      
      if(isNaN($x)){
                    
      }else{
        if((typeof $x === "undefined") || ($x == "") || ($x == "0.00")){
          $(".grid-product__price").html('<span data-price="" class="5 normalPrice product__price grid-product__price--original" data-product-price="">$' + $y + '</span>')
        }else{
          $(".grid-product__price").html('<del data-price="" class="5 normalPrice product__price grid-product__price--original ">$' + $x + '</del><div class="sale-price">$' + $y + '</div>')
        }
      }
  }

    var handle = $(this).attr("data-handle");
              var boser = false;
                      var t = $(this).attr("data-handle");
                
            for (let i = 0; i < colorarray.length; i++) {
                const myArray = colorarray[i].split(" - ");
                

                var jj = $(this).find("label").attr("op_val");
                var kk = myArray[1].toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
                jj = jj.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
                
                
                if(jj == kk){
                    var ll = myArray[2];
                    $(".datahere").html(ll)
                    $(".dotspacer").show()
                    boser = true;
                }else{
                    
                }
            }
            if (boser == false){
                $(".datahere").html("")
                $(".dotspacer").hide()
            }
  
    setTimeout(function(){

      var me = getUrlVars()["variant"];
      if(handle == 'current'){
        var dataURL= window.location.href;
        console.log(dataURL);
      }
      else{
        var location_handle = window.location.href;
        if (window.location.href.indexOf("/collections/") > -1) {
          var dtaa_local = location_handle.split("/")[6];
          var final_locate = dtaa_local.split("?")[0];
          var dataURL= location_handle.replace(final_locate,handle);
          console.log("test");
        }
        else{
          var dtaa_local = location_handle.split("/")[4];
          var final_locate = dtaa_local.split("?")[0];
          var dataURL= location_handle.replace(final_locate,handle);
          console.log("test222");
        }

      }

      $.ajax({
        type:'GET',
        url:dataURL,
        datatype:"HTML",
        beforeSend: function() {
        },
         complete: function(){
             setTimeout(function(){ 
            $('.product__photos').css('opacity',1);
             },1000);
    },
        success:function(data){
          var html=$(data).find(".product__photos").html();
          $(".product__photos").html(html);
          $('.product__thumbs').slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            arrows: false,
            fade: false,
            vertical:true
          });

          if($(window).width()<=768){
            $('.Main--ProductPhotos').slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              dots: true
            });
          }

          $('.product__thumb-item:eq(0)').trigger('click');
          $('.product__thumb-item.slick-active.slick-current').trigger('click');
          $('.product__photos').css('opacity',0);

        }
      });
    },100);
  });

  $(document).on('click',".product__thumb-item",function(event){
    event.preventDefault();
    var index=$(this).attr('data-index');
    $('.product__thumb-item').removeClass('Active--slide');
    $(this).addClass('Active--slide');
    $('.product__main-photos-wrapper .product__slide').removeClass('starting-slide');
    $('.product__main-photos-wrapper .product__slide').addClass('secondary-slide');
    $('.product__main-photos-wrapper .product__slide[data-index="'+index+'"]').addClass('starting-slide');
    $('.product__main-photos-wrapper .product__slide[data-index="'+index+'"]').removeClass('secondary-slide');

    if($(this).find('.product__thumb span').hasClass('product__thumb-icon')){
      $('.product__slide.starting-slide video').trigger('play');}
    else {
      $('.product__slide video').trigger('pause');
    }


  });


  $(document).on('afterChange','.Main--ProductPhotos' ,function(event, slick, currentSlide, nextSlide){
    console.log(nextSlide);
    setTimeout(function(){
      if(jQuery('.Main--ProductPhotos .slick-current.slick-active').find('div').hasClass('product__video-wrapper')){
        jQuery('.Main--ProductPhotos .slick-current.slick-active video').trigger('play');}
      else
      {
        jQuery('.product__slide video').trigger('pause');
      }
    },300);
  });


  $(".Main--ProductPhotos").on('beforeChange', function(event, slick, currentSlide) {

    setTimeout(function(){
      if(jQuery('.Main--ProductPhotos .slick-current.slick-active').find('div').hasClass('product__video-wrapper')){
        console.log('111111111111');
        jQuery('.Main--ProductPhotos .slick-current.slick-active video').trigger('play');}
      else
      {
        console.log('222222222222');
        jQuery('.product__slide video').trigger('pause');
      }
    },300);
  });
  jQuery('.Main--ProductPhotos').on("beforeChange", function (){
    console.log('chnage Event');

    setTimeout(function(){
      if(jQuery('.Main--ProductPhotos .slick-current.slick-active').find('div').hasClass('product__video-wrapper')){
        console.log('111111111111');
        jQuery('.Main--ProductPhotos .slick-current.slick-active video').trigger('play');}
      else
      {
        console.log('222222222222');
        jQuery('.product__slide video').trigger('pause');
      }
    },300);
  });




  $("button.label.collapsible-trigger.collapsible-trigger-btn.collapsible-trigger-btn--borders").eq(0).trigger("click");
});

jQuery(document).on("click",".custom-ajax-size .variant-input",function(){

  $size = $(".variant-input-wrap[data-index='option1'] input:checked").val();
  $color = $(".variant-input-wrap[data-index='option2'] input:checked").val();
  if($(".variant-input-wrap[data-index='option3']").length){
      $inseam = $(".variant-input-wrap[data-index='option3'] input:checked").val();
      var setchosen = $size + " / " + $color + " / " + $inseam;
      setchosen = setchosen.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      $x = parseFloat(comprice[setchosen] / 100).toFixed(2);
      $y = parseFloat(normprice[setchosen] / 100).toFixed(2);
      console.log($x + " | " + $y + " | " + setchosen)
      if(isNaN($x)){
                    
      }else{
        if((typeof $x === "undefined") || ($x == "") || ($x == "0.00")){
          $(".grid-product__price").html('<span data-price="" class="5 normalPrice product__price grid-product__price--original" data-product-price="">$' + $y + '</span>')
        }else{
          $(".grid-product__price").html('<del data-price="" class="5 normalPrice product__price grid-product__price--original ">$' + $x + '</del><div class="sale-price">$' + $y + '</div>')
        }
      }
  }else{
      
      var setchosen = $size + " / " + $color;
      setchosen = setchosen.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      $x = parseFloat(comprice[setchosen] / 100).toFixed(2);
      $y = parseFloat(normprice[setchosen] / 100).toFixed(2);
      if(isNaN($x)){
                    
      }else{
        if((typeof $x === "undefined") || ($x == "") || ($x == "0.00")){
          $(".grid-product__price").html('<span data-price="" class="5 normalPrice product__price grid-product__price--original" data-product-price="">$' + $y + '</span>')
        }else{
          $(".grid-product__price").html('<del data-price="" class="5 normalPrice product__price grid-product__price--original ">$' + $x + '</del><div class="sale-price">$' + $y + '</div>')
        }
      }
  }


  var getdata=$(this).attr('data-value').trim();
  var getdataFinal=getdata.toLowerCase();
  var Final_Data= $('.displayHidden span[data-matched="'+getdataFinal+'"]').html();
  $(this).parents('.variant-wrapper').find('.variant__label .variant__label-info .custom-option-value').html(Final_Data);
});




$('.input-group').on('click', '.button-plus', function(e) {
  e.preventDefault();
  var fieldName = $(e.target).data('field');
  var parent = $(e.target).closest('div');
  var currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);
  if (!isNaN(currentVal)) {
    parent.find('input[name=' + fieldName + ']').val(currentVal + 1);
  } else {
    parent.find('input[name=' + fieldName + ']').val(0);
  }
});

$('.input-group').on('click', '.button-minus', function(e) {
  e.preventDefault();
  var fieldName = $(e.target).data('field');
  var parent = $(e.target).closest('div');
  var currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);
  console.log(currentVal);
  if(currentVal== 1){
    parent.find('input[name=' + fieldName + ']').val(1);
  }
  else{
    if (!isNaN(currentVal) && currentVal > 0) {
      parent.find('input[name=' + fieldName + ']').val(currentVal - 1);
    } else {
      parent.find('input[name=' + fieldName + ']').val(0);
    }
  }
}),
  $(".product-tabs-data").click(function () {
        var t = $(this).attr("value");
        $counterat = 0;
        $(".product-tabs-data").removeClass("tag--active"),
            $(this).addClass("tag--active"),
            $("div#CollectionAjaxContent .grid__item").hide(),
            $("div#CollectionAjaxContent .grid__item").each(function () {
                $.trim($(this).find("span.product__title_color_variants").attr("var-name")).includes(t) && $(this).show();
                if($(this).hasClass("main-metafield-image")){
                    $(this).show()
                }
            }),
            $itemcount = parseInt($("div#CollectionAjaxContent .grid__item:visible").length) - 2;
            
            $("div#CollectionAjaxContent .grid__item:visible").each(function () {
              $(this).css('order', $counterat )
              $counterat++;
            });
            if(($itemcount > 0) && ($itemcount < 7)){
                $(".main-metafield-image").eq(1).hide(),
                $(".main-metafield-image").eq(0).css('order', -1 )
                
            }else{
                
                $(".main-metafield-image").eq(0).css('order', -1 )
                $(".main-metafield-image").eq(1).css('order', 10 )
            }
            
            /*
            $("div#CollectionAjaxContent .grid__item").each(function () {
                $.trim($(this).find("span.product__title_color_variants").attr("var-name")).includes(t) && $(this).show();
            });
            */
    }),
  $(document).ready(function(){
setTimeout(function() {
$(".zip-widget__wrapper").addClass('hide');
var get_html = $(".zip-widget__wrapper").html();
$(get_html).insertAfter('.afterpay-paragraph');
$(".zip-widget__wrapper").addClass('active');

  }, 1000);



  if ($(window).width() < 769) {
    $("ul.no-bullets.tag-list.tag-list--swatches.slick-carousel").slick({
      autoplay: false,
      infinite: false,
      slidesToShow: 10,
      slidesToScroll: 1,
      responsive: [

        {
          breakpoint: 600,
          settings: {
            slidesToShow: 8,
            slidesToScroll: 1
          }
        }
      ]
    });
  } else if ($("ul.no-bullets.tag-list.tag-list--swatches.slick-carousel").hasClass("slick-initialized")) {
    $("ul.no-bullets.tag-list.tag-list--swatches.slick-carousel").slick("unslick");
  }
});
$(window).on('resize', function(){

  if ($(window).width() < 769) {
    $("ul.no-bullets.tag-list.tag-list--swatches.slick-carousel").slick({
      autoplay: false,
      infinite: false,
      slidesToShow: 10,
      slidesToScroll: 1,
      responsive: [

        {
          breakpoint: 600,
          settings: {
            slidesToShow: 8,
            slidesToScroll: 1
          }
        }

      ]
    });
  } else if ($("ul.no-bullets.tag-list.tag-list--swatches.slick-carousel").hasClass("slick-initialized")) {
    $("ul.no-bullets.tag-list.tag-list--swatches.slick-carousel").slick("unslick");
  }
});

  $(document).on('change',".product-section.is-modal .variant-input input",function(event){
var get_id= $("select.custom-product-single__variants.no-js option:selected").attr('value');
 var url = window.location.href;
if (url.indexOf("=") > 0) {
     var updatedUri = url.substring(0, url.indexOf("=")) + "=" +get_id;
    
     window.history.replaceState({}, document.title, updatedUri);
}
});



$(document).ready(function () {

  $(document).on("click", ".variant-input[data-index='option3'] .label_options", function (t) {
    $ok1 = "notok";
    $oknarin1 = "not ok"
    $size = $(".variant-input-wrap[data-index='option1'] input:checked").val();
    $color = $(".variant-input-wrap[data-index='option2'] input:checked").val();
    if($(".variant-input-wrap[data-index='option3']").length){
        $inseam = $(".variant-input-wrap[data-index='option3'] input:checked").val();
        var setchosen = $size + " / " + $color + " / " + $inseam;
        setchosen = setchosen.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
        $x = parseFloat(comprice[setchosen] / 100).toFixed(2);
        $y = parseFloat(normprice[setchosen] / 100).toFixed(2);
        console.log($x + " | " + $y + " | " + setchosen)
        if(isNaN($x)){
                    
        }else{
          if((typeof $x === "undefined") || ($x == "") || ($x == "0.00")){
          $(".grid-product__price").html('<span data-price="" class="5 normalPrice product__price grid-product__price--original" data-product-price="">$' + $y + '</span>')
        }else{
          $(".grid-product__price").html('<del data-price="" class="5 normalPrice product__price grid-product__price--original ">$' + $x + '</del><div class="sale-price">$' + $y + '</div>')
        }
        }
    }else{
        
        var setchosen = $size + " / " + $color;
        setchosen = setchosen.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
        $x = parseFloat(comprice[setchosen] / 100).toFixed(2);
        $y = parseFloat(normprice[setchosen] / 100).toFixed(2);
        if(isNaN($x)){
                    
        }else{
          if((typeof $x === "undefined") || ($x == "") || ($x == "0.00")){
            $(".grid-product__price").html('<span data-price="" class="5 normalPrice product__price grid-product__price--original" data-product-price="">$' + $y + '</span>')
          }else{
            $(".grid-product__price").html('<del data-price="" class="5 normalPrice product__price grid-product__price--original ">$' + $x + '</del><div class="sale-price">$' + $y + '</div>')
          }
        }
    }

})


  $(".close-button").click(function(){
      $(".pop-up-modal").removeClass("show-pop-up");
  })
  setTimeout(function () {
      $(".zip-widget__wrapper").addClass("hide");
      var t = $(".zip-widget__wrapper").html();
      $(t).insertAfter(".afterpay-paragraph"), $(".zip-widget__wrapper").addClass("active");
  }, 1e3),
      769 > $(window).width()
          ? $("ul.no-bullets.tag-list.tag-list--swatches.slick-carousel").slick({ autoplay: !1, infinite: !1, slidesToShow: 10, slidesToScroll: 1, responsive: [{ breakpoint: 600, settings: { slidesToShow: 8, slidesToScroll: 1 } }] })
          : $("ul.no-bullets.tag-list.tag-list--swatches.slick-carousel").hasClass("slick-initialized") && $("ul.no-bullets.tag-list.tag-list--swatches.slick-carousel").slick("unslick");
}),
$(window).on("resize", function () {
  769 > $(window).width()
      ? $("ul.no-bullets.tag-list.tag-list--swatches.slick-carousel").slick({ autoplay: !1, infinite: !1, slidesToShow: 10, slidesToScroll: 1, responsive: [{ breakpoint: 600, settings: { slidesToShow: 8, slidesToScroll: 1 } }] })
      : $("ul.no-bullets.tag-list.tag-list--swatches.slick-carousel").hasClass("slick-initialized") && $("ul.no-bullets.tag-list.tag-list--swatches.slick-carousel").slick("unslick");
}),
$(document).on("change", ".product-section.is-modal .variant-input input", function (t) {
  var i = $("select.custom-product-single__variants.no-js option:selected").attr("value"),
      e = window.location.href;
      
  if (e.indexOf("=") > 0) {
      var s = e.substring(0, e.indexOf("=")) + "=" + i;
      window.history.replaceState({}, document.title, s);
  }
});








var xxx = $(".varin[checked='checked']").attr("op_val")
var yyy = $(".variant__label span[data-option-index='1']").html()
var curr_indx = yyy;
var curr_val = xxx
var optionlength = $('.variant-wrapper').length;
jsonoption = {};
var optionlength = $('.variant-wrapper').length;
$(this).parents('.variant-wrapper').find('.variant__label-info span').html(curr_val);
$('.product-single__variants.no-js option').each(function () {
 var name = $(this).attr('varname');

 var available = $(this).data('avail');

 jsonoption[name] = available;
  
});

setTimeout(function () {
$(".varin:disabled[option_index='2']").each(function () {
$(this).parent().addClass("supdis")
});
}, 1000);
  
if (optionlength == 3) {


}   
else{

$(".label_options[option_index='2']").each(function () {
  var index2 = $(this).attr("op_val");
  var created_option = xxx + ' / ' + index2;
  var getoption_array = jsonoption[created_option];
  console.log(getoption_array)
  $(this).parent().removeClass("disabled");


   if ((typeof getoption_array == 'undefined')) {

      $(this).parent().addClass("supdis")
   }else{
      if (getoption_array == "unavailable") {

         
         $(this).parent().removeClass("supdis")
      }
   }    
});


$(".label_options[option_index='1']").each(function () {
  var index1 = $(this).attr("op_val");
  var created_option = index1 + ' / ' + yyy.trim();
  var getoption_array = jsonoption[created_option];
  console.log(getoption_array)
  $(this).parent().removeClass("disabled");
  
  
   if ((typeof getoption_array == 'undefined')) {

      $(this).parent().addClass("supdis")
     
   }else{
      if (getoption_array == "unavailable") {

         
         $(this).parent().removeClass("supdis")
      }
   }    
   
});
}

$('html, body').animate({
scrollTop: $("body").offset().top
}, 1);
setTimeout(function() {


$('html, body').animate({
scrollTop: $("body").offset().top
}, 1);
}, 500);
$(".custom-option-value").html($(".varin[name=Size][checked=checked").val())

$(document).ready(function(){

  if($("body").hasClass("template-scrubs")){
    $('.add-to-cart').on('click', function(e) {
      e.preventDefault()
     
      if($('.variant-wrapper:nth-of-type(3) .variant__label-info span').length){
          $aet = $.trim($(".variant-wrapper .custom-option-value").html()) + " / " +  $.trim($(".variant-change-color .variant__label-info span:first-child").html()) + " / " + $.trim($('.variant-wrapper:nth-of-type(3) .variant__label-info span').html())
      }else{
          $aet = $.trim($(".variant-wrapper .custom-option-value").html()) + " / " +  $.trim($(".variant-change-color .variant__label-info span:first-child").html())
      }
     
      
      $(".product-single__variants").children()
          .each(function () {
               
              if($(this).attr("varname") == $aet){
     
                  $actualvarid = $(this).val()
                  $dataazz = {
                      "id": $actualvarid,
                      "quantity": 1
                   }
                
                    
                   jQuery.ajax({
                      type: 'POST',
                      url: '/cart/add.js',
                      data: $dataazz,
                      dataType: 'json',
                      success: function (e) {
                           cart_update();
                          
                      }
                   })
              }
      });
     });
     
  }


})

function cart_update() {
  $.ajax({
      url: "/",
      type: "GET",
      dataType: "html",
      success: function (t) {

        $("body").addClass("cart-has-items")


          $(".cart_count_icon").html($(t).find(".cart_count_icon").html()),
              $(".drawer__inner").removeClass("overlay-applied"),
              $(".cart_drawer_custom").html($(t).find(".cart_drawer_custom").html()),
              $(".unlockmsg").html($(t).find(".unlockshtml").html()),
              $(".cart-all-products").slick({ dots: !0, infinite: !0, speed: 300, slidesToShow: 1, slidesToScroll: 1, dots: !0, arrows: !0 });
              $(".js-drawer-open-cart").trigger("click");
              let totalQuantity = 0;
                  $('.cart__items .grid .grid__item').each(function() {
                    const quantity = parseInt($(this).find('.cart__quantity').val()) || 0;
                    totalQuantity += quantity;
                  });
                  $(".cart-link__count").html(totalQuantity)
      },
      error: function (t, e, i) {},
  });
  }
  
